module.exports = __webpack_public_path__ + "static/media/not-found.275fa497.png";